export function isHtmlElement(element: HTMLElement | typeof window): element is HTMLElement {
  return (element as HTMLElement).scrollTop !== undefined
}
